import { Button } from '@fukuri-admins/ui/common';
import { TextInputFieldController } from '@fukuri-admins/ui/common/Form';
import { useFormContext } from 'react-hook-form';
import { FileInputFieldController } from '~/ui/domain/portal/FileInputFieldController';
import { PortalModal } from '~/ui/domain/portal/Modal';
import { PortalSelect } from '~/ui/domain/portal/select';
import styles from './styles.module.scss';

type Props = {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  selectedFile: File | undefined;
  existingFileUrl: string | undefined;
  hasFile: boolean;
  onFileChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onRemoveFile: () => void;
};

const getFileNameFromUrl = (url: string): string => {
  try {
    const urlObj = new URL(url);
    const pathname = urlObj.pathname;
    const fileName = pathname.split('/').pop() || '';
    return decodeURIComponent(fileName);
  } catch {
    return url.split('/').pop() || url;
  }
};

export const EditPortalModalPresentation: React.FC<Props> = ({
  isOpen,
  onClose,
  onConfirm,
  selectedFile,
  existingFileUrl,
  hasFile,
  onFileChange,
  onRemoveFile,
}) => {
  const { register } = useFormContext();
  const displayFileName =
    selectedFile?.name || (existingFileUrl ? getFileNameFromUrl(existingFileUrl) : undefined);

  return (
    <PortalModal isOpen={isOpen} onClose={onClose} title='ポータルの編集'>
      <form className={styles.formContainer} onSubmit={onConfirm}>
        {/* アイコン選択 */}
        <PortalSelect name='icon_name' label='アイコン' placeholder='アイコンを選択してください' />

        {/* 表示名 */}
        <TextInputFieldController
          name='title'
          fieldWrapperProps={{
            labelText: '表示名',
          }}
          textInput={{
            placeholder: 'ポータル名を入力',
            type: 'text',
          }}
        />

        {/* 項目セクション */}
        <div className={styles.itemSection}>
          <span className={styles.itemSectionLabel}>項目</span>

          {/* リンク追加オプション */}
          <label className={styles.radioLabel}>
            <input type='radio' value='url' {...register('item_type')} />
            リンクを追加する
          </label>
          <div className={styles.itemContent}>
            <TextInputFieldController
              name='url'
              fieldWrapperProps={{
                labelText: '',
              }}
              textInput={{
                placeholder: 'https://example.com',
                type: 'url',
              }}
            />
          </div>

          {/* ファイル追加オプション */}
          <label className={styles.radioLabel}>
            <input type='radio' value='file' {...register('item_type')} />
            ファイルを追加する
          </label>
          <div className={styles.itemContent}>
            <FileInputFieldController
              name='file'
              label=''
              accept='application/pdf'
              selectedFile={selectedFile}
              displayFileName={displayFileName}
              hasFile={hasFile}
              onFileChange={onFileChange}
              onRemoveFile={onRemoveFile}
            />
          </div>
        </div>
        <div className={styles.buttonContainer}>
          <Button variant='outline' onClick={onClose}>
            キャンセル
          </Button>
          <Button variant='primary' type='submit'>
            更新
          </Button>
        </div>
      </form>
    </PortalModal>
  );
};
